var map = {
	"./FaceAI-mockup1.png": "1047",
	"./FaceAI-mockup2.png": "ea43",
	"./FaceAI-mockup3.png": "6cc9",
	"./FaceAI4.jpg": "8d33",
	"./accesspermissions1.jpg": "6250",
	"./annualization1.jpg": "eb26",
	"./approval1.jpg": "a3ce",
	"./attendance1.jpg": "458b",
	"./attendance2.jpg": "659c",
	"./backup/landing1.jpg": "3dfd",
	"./backup/landing2-a.jpg": "a521",
	"./backup/landing2-b.jpg": "926e",
	"./backup/landing2-c.jpg": "6496",
	"./cloud1.png": "56b9",
	"./cloud2.png": "2cbd",
	"./compensation1.jpg": "9f2b",
	"./edocuments.jpg": "5a29",
	"./faceai1.jpg": "18df",
	"./faceai1.png": "5495",
	"./finance1.jpg": "9c71",
	"./hr201files.jpg": "58fe",
	"./landing1.webp": "9b53",
	"./landing2.jpg": "40ba",
	"./landing3.jpg": "8499",
	"./landing4.webp": "272a",
	"./landing5.jpg": "7e23",
	"./landing6.jpg": "4871",
	"./landing6.webp": "46f9",
	"./landing7.jpg": "05e8",
	"./landing8.jpg": "19ea",
	"./landing9.jpg": "cab1",
	"./laptop-mock.png": "5305",
	"./one_platform.jpg": "44ea",
	"./one_platform.png": "9468",
	"./one_platform2.png": "cae6",
	"./our-customers.jpg": "dac5",
	"./our-customers2.jpg": "e798",
	"./paryoll1.jpg": "ff4f",
	"./projects1.jpg": "2796",
	"./security1.jpg": "0e5b",
	"./security2.png": "151d",
	"./security3.png": "e680",
	"./security4.png": "2d5d",
	"./selfservice1.jpg": "376f",
	"./testimonials.jpg": "ba36",
	"./testimonials2.jpg": "3841",
	"./themes1.jpg": "d39a",
	"./themes2.jpg": "141b",
	"./why-choose-us.jpg": "e400",
	"./why-choose-us.png": "b9f4",
	"./why-choose-us2.jpg": "e67d",
	"./workshift-plan1.jpg": "4cbd",
	"./workshift-plan2.jpg": "13cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bed";